<template>
  <section class="section">
    <b-field class="regionSelector" label="Region">
      <b-select v-bind:value="this.currentSelected" style="margin-right: 15px" v-on:input="onChange">
        <option v-for="region in this.regions" :value="region.Name" :key="region.Name">{{ region.Name }}</option>
      </b-select>
    </b-field>
    <div class="container">
      <button class="button is-primary is-medium" @click="isModalActive = true">New Provider</button>
      <b-table
        :data="providersList"
        ref="table"
        paginated
        per-page="10"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        detailed
        :loading="loading"
      >
        <b-table-column field="providerID" label="ProviderID" width="40" numeric v-slot="props">{{ props.row.providerID }}</b-table-column>

        <b-table-column field="providerName" label="Provider Name" sortable v-slot="props">{{ props.row.providerName }}</b-table-column>
        <b-table-column field="providerDefaultLookupType" label="Provider Default LookupType" sortable v-slot="props">{{ props.row.providerDefaultLookupType }}</b-table-column>

        <b-table-column label="Actions" v-slot="props">
          <b-button type="is-danger" @click="confirmDeleteProvider(props.row.providerID)">Delete Provider</b-button>
        </b-table-column>
        <template slot="detail" slot-scope="detailProps">
          <b-table :data="detailProps.row.providerTypes" ref="table">
            <b-table-column field="providerTypeID" label="ProviderTypeID" centered v-slot="props">{{ props.row.ProviderTypeID }}</b-table-column>
            <b-table-column field="providerType" label="ProviderType" centered v-slot="props">{{ props.row.ProviderType }}</b-table-column>
          </b-table>
        </template>
      </b-table>
    </div>
    <!-- Modal -->
    <b-modal :active.sync="isModalActive" :width="300" scroll="keep">
      <form v-on:submit.prevent="createProvider">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">New Provider</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Provider Name">
              <b-input type="text" v-model="formProps.name" placeholder="Provider Name" required></b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="isModalActive = false">Close</button>
            <button class="button is-primary">Save</button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import axios from "axios";
import { ToastProgrammatic as Toast } from "buefy";
import Provider from "../models/provider";

let GlobalConfig = require("../config/index");
GlobalConfig = GlobalConfig.default;

export default {
  name: "Providers",
  data: function () {
    return {
      isModalActive: false,
      formProps: {},
      providersList: [],
      regions: [],
      currentSelected: "",
      loading: true,
    };
  },
  async beforeMount() {
    GlobalConfig = require("../config/index").default;
    this.regions = GlobalConfig.API_SERVERS;
    this.currentSelected = GlobalConfig.GetAPIName();
    await this.GetProviderData();
  },
  methods: {
    GetProviderData: async function () {
      this.loading = true;
      this.providersList = [];
      try {
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        const providersGet = await axios.get(`${GlobalConfig.GetAPIURL()}/api/providers`, config);

        providersGet.data.forEach((provider) => {
          // eslint-disable-next-line max-len
          const index = this.providersList.push(new Provider(provider.ProviderID, provider.ProviderName, provider.DefaultLookupType)) - 1;

          for (const [key, value] of Object.entries(provider.Types)) {
            value.ProviderType = key;
            if (typeof (this.providersList[index].providerTypes === undefined)) this.providersList[index].providerTypes = [];
            this.providersList[index].providerTypes.push(value);
          }
        });
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    createProvider: async function () {
      try {
        const providerData = {
          ProviderName: this.formProps.name,
        };
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        await axios.post(`${GlobalConfig.GetAPIURL()}/api/providers`, providerData, config);
        Toast.open({
          message: "Successfully created provider!",
          type: "is-success",
        });
        this.isModalActive = false;
        await this.GetProviderData();
      } catch (error) {
        Toast.open({
          message: "An error occured adding provider!",
          type: "is-danger",
        });
        // console.error(error);
      }
    },
    confirmDeleteProvider: function (providerID) {
      this.$buefy.dialog.confirm({
        title: "Deleting Provider",
        message: "Are you sure you want to <b>delete</b> this provider? This action cannot be undone.",
        confirmText: "Delete Provider",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteProvider(providerID),
      });
    },
    deleteProvider: async function (providerID) {
      try {
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        await axios.delete(`${GlobalConfig.GetAPIURL()}/api/providers/${providerID}`, config);
        Toast.open({
          message: "Successfully deleted provider!",
          type: "is-success",
        });
        await this.GetProviderData();
      } catch (error) {
        Toast.open({
          message: "An error occured deleting Provider record!",
          type: "is-danger",
        });
        // console.error(error);
      }
    },
    onChange(changedTo) {
      localStorage.setItem("APIName", changedTo);
      this.currentSelected = GlobalConfig.GetAPIName();
      this.GetProviderData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section {
  position: relative;
}
.regionSelector {
  top: 10px;
  right: 10px;
  position: absolute;
}
</style>
